export class FeedStockSymbol {
	MarketName: string;
	MarketSymbol: string;
	StockSymbol: string;
	StockName: string;
}
